<div class="d-flex flex-column general-layout">
  <div>
    <app-header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="content-layout" id="content-layout-id">

    <main class="scroll" id="interno">
      <div class="information">
        <router-outlet *ngIf="!isIframe"></router-outlet>
      </div>
      <aside>
        <app-accesibility></app-accesibility>
      </aside>

      <app-go-up></app-go-up>

      <div class="linea">
        <app-footer></app-footer>
      </div>
    </main>
  </div>
</div>
